import { StyleSheet, View } from 'react-native';

import { IconMoney, IconRedeem, Text, XStack, YStack, tokens } from '@fhs/ui';

import { maskCardNumber } from '../../utils/helpers';

type GiftCardInfoProps = {
  lastCardDigits: string;
  balance: string;
};

export const GiftCardInfo = ({ lastCardDigits, balance }: GiftCardInfoProps) => {
  const formattedLastCardDigits = maskCardNumber({ lastDigits: lastCardDigits });

  return (
    <YStack style={styles.contentWrapper}>
      <XStack style={styles.row}>
        <XStack style={styles.rowStart}>
          <View style={styles.iconCircle}>
            <IconRedeem size={24} color={tokens.colors.$houseDark} />
          </View>
          <Text>CARD #: {formattedLastCardDigits}</Text>
        </XStack>
      </XStack>
      <XStack style={styles.row}>
        <XStack style={styles.rowStart}>
          <View style={styles.iconCircle}>
            <IconMoney size={24} color={tokens.colors.$houseDark} />
          </View>
          <Text>Current Balance</Text>
        </XStack>
        <Text weight="semibold">{balance}</Text>
      </XStack>
    </YStack>
  );
};

const styles = StyleSheet.create({
  contentWrapper: {
    paddingHorizontal: 16,
    borderWidth: 1,
    borderColor: tokens.colors.$blackOpacity10,
    borderRadius: 8,
  },
  row: {
    paddingVertical: 16,
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  },
  rowStart: {
    alignItems: 'center',
    gap: 12,
  },
  iconCircle: {
    height: 40,
    width: 40,
    borderRadius: 100,
    gap: 10,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: tokens.colors.$blackOpacity04,
  },
});
